<template>
	 <v-container grid-list-md class="mt-3">
	    <v-layout row wrap>
			<v-flex xs12 lg8 offset-lg2>
			    <v-alert color="error" icon="warning" v-model="error.show" transition="scale-transition">
			      {{error.message}}
			    </v-alert>
	    	</v-flex>

		<v-flex xs12 lg10 offset-lg1>
		    <v-alert color="success" icon="check_circle" v-model="success" transition="scale-transition">
		      Message sent! 
		    </v-alert>
    	</v-flex>

		     <v-flex xs12 lg8 offset-lg2 class="mt-2">

		        <v-card light color="white" @keypress.enter="sendMessage">	        	     	
		            <v-card-title class="title primary white--text">  <v-icon class="mr-2">mail</v-icon> Contact</v-card-title>

		         <v-card-text>
					<v-text-field
					  name="name"
					  label="Name"
					  id="name"
					  v-model="name"
					  :disabled="disable"
					  :error-messages="errors.name.message"
					  required
					></v-text-field>

					<v-text-field
					  name="email"
					  label="Email"
					  id="email"
					  v-model="email"
					  :disabled="disable"
					  :error-messages="errors.email.message"
					  required
					></v-text-field>

					<v-text-field
					  name="subject"
					  label="subject"
					  id="subject"
					  v-model="subject"
					  :disabled="disable"
					  :error-messages="errors.subject.message"
					  required
					></v-text-field>

					<v-text-field
					  name="message"
					  label="Message"
					  id="message"
					  v-model="message"
					  :disabled="disable"
					  :error-messages="errors.message.message"
					  required
					  multi-line
					></v-text-field>

					<vue-recaptcha sitekey="6LfB8y8UAAAAAOc_QbTHyEiNFi092OTJr0msSD_u" @expired="setError('reCapthca Expired')" @verify="verify" ref="recaptcha"></vue-recaptcha>

					<v-divider class="mt-4 mb-2"></v-divider>

					<v-btn color="primary" @click="sendMessage()" :loading="submitting" :disabled="disable">Send Message</v-btn>
				</v-card-text>
			</v-card>
		</v-flex>
		</v-layout>
	</v-container>
</template>

<script type="text/javascript">
import Loading from '@/mixins/Loading'
import ErrorHandler from '@/mixins/ErrorHandler'
import VueRecaptcha from 'vue-recaptcha'

export default {
	name: 'Contact',
	mixins: [Loading, ErrorHandler],
	components:{
		VueRecaptcha
	},
	created() {
		this.initValidator(['name','email', 'subject', 'message'])
		this.name = this.$store.state.user.name;
		this.email = this.$store.state.user.email;
	},
	methods: {
		sendMessage() {
			this.submitting = true
			this.clearErrors()
			this.error.show = false
			this.success = false
			axios.post('/api/message', {
				name: this.name,
				email: this.email,
				subject: this.subject,
				message: this.message,
				verify: this.verifyResponse
			}).then(response => {
				this.submitting = false
				this.success = true
			}).catch(error => {
				this.handleErrors(error)
				this.submitting = false
				this.$refs.recaptcha.reset()
			});
		},
		setError(message) {
			this.error.show = true
			this.error.message = message
		},
		verify(response) {
			this.verifyResponse = response
		}
	},
	computed: {
		disable() {
			return this.loading || this.submitting
		}
	},
	data() {
		return {
			submitting: false,
			verifyResponse: '',
			success: false,
			name: '',
			email: '',
			subject: '',
			message: ''
		}
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/views/Contact.vue